import React, { Component } from "react";
import "@ant-design/compatible/assets/index.css";
import fetchHandler from "@/fetch/fetchHandler";
import GridTable from "@/components/display/table/gridTableCore";
import { initModals } from "@/state/action/comAction";
import { deleteRole, getRoleList } from "@/fetch/fetchApi";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import RefreshGrid from "@/utils/refreshGrid";
import PropTypes from "prop-types";
import FormCore from "@/components/display/form/formCore";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import EditRoleModal from "./editRoleModal";

@connect((state) => state)
class RoleList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      editRoleModelVisible: false,
      internationalization: this.props.intl.messages.roleList,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];

    this.modalConfig = [
      {
        key: "editRoleModal",
        width: 600,
        title: this.state.internationalization.title1, // '角色设置',
        content: EditRoleModal,
      },
    ];
  }

  componentWillMount() {
    this.init();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          inputType: "text",
          param: {
            name: "name", // 提交的参数
            type: "string",
          },
          labelName: this.state.internationalization.title2, // '角色名称',
          placeholder: this.state.internationalization.placeholder1, // '请输入角色名称'
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.state.internationalization.btn1, // '查询',
              // icon: 'search'
            },
            {
              btnType: "button",
              text: this.state.internationalization.btn2, // '新增角色',
              icon: "plus",
              handler: () => {
                this.context.store.dispatch(
                  initModals("editRoleModal", {
                    defaultSource: [],
                  }),
                );
              },
            },
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "roleListTable",
    };

    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: this.state.internationalization.title3, // '角色名称',
            key: "name",
            align: "left",
            width: "33%",
            colType: "textCol",
          },
          {
            name: this.state.internationalization.title4, // '状态',
            dataIndex: "type",
            key: "status",
            align: "left",
            width: "33%",
            colType: "textCol",
            render: (text) => (
              <div>
                {text.toString() === "1"
                  ? this.state.internationalization.state1
                  : this.state.internationalization.state2}
              </div>
            ),
          },
          {
            name: this.state.internationalization.action, // '操作',
            key: "action",
            align: "center",
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: this.state.internationalization.btn3, // '编辑角色',
                handler: (res) => {
                  // debugger;
                  const targetArr = res.permissionIds ? res.permissionIds.split(",") : [];
                  this.openNewRole(res.key, res.name, targetArr);
                  // this.setState({
                  //     editRoleModelVisible : true,
                  //     roleId:res.key,
                  //     roleName:res.name,
                  //     defaultTarget:targetArr
                  // })
                },
              },
              {
                type: "confirm",
                actionName: this.state.internationalization.btn4, // '删除', // 默认actionName
                render: (record) => {
                  // debugger;
                  return record.key === "1" ? null : (
                    <span className="tableBtn">{this.state.internationalization.btn4}</span>
                  );
                },
                // 根据grid数据 自定义显示actionName
                handler: (res) => {
                  // debugger;
                  fetchHandler(deleteRole, {
                    roleId: res.key,
                  }).then((result) => {
                    if (result.code === "success") {
                      RefreshGrid(this.context.store, "roleListTable");
                    }
                  });
                },
              },
            ],
          },
        ],
        tableParam: {
          pagecount: 10,
        },
        tableInfo: {
          // hasRow: !0, // 是否显示checkbox
          // rowSelection: {
          //     onChange: (selectedRowKeys, selectedRows) => {
          //         this.selectedRows = selectedRows;
          //     },
          //     getCheckboxProps: record => ({
          //         disabled: record.companyName === '宝马',
          // Column configuration not to be checked
          //         name: record.name,
          //     })
          // }
        },
        dataApi: getRoleList,
        autoRefresh: 1, // 设置为true 直接加载grid数据
        tableKey: "roleListTable",
      },
    });
  }

  openNewRole(roleId, name, targetArr) {
    const editParam = roleId
      ? {
        roleId: roleId,
        name: name,
      }
      : {};
    this.context.store.dispatch(
      initModals("editRoleModal", {
        ...editParam,
        defaultSource: [],
        defaultTarget: targetArr,
      }),
    );
    console.log(this.context);
    // this.getPermissionList().then(res => {
    //
    // });
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  render() {
    const Content = (
      <div className='sc-page-content'>
        <div className='page-panel'>
          {/* <Input style={{width:'200px',marginRight:'20px'}} placeholder='请输入角色名称'/> */}
          {/* <Button */}
          {/*    type="primary" */}
          {/*    onClick={this.handleQryBtnClick} */}
          {/*    icon="search" */}
          {/* >查询</Button> */}

          {/* <Button type="primary" title="新增角色" onClick={()=>{ */}
          {/*    this.context.store.dispatch(initModals('editRoleModal', { */}
          {/*        defaultSource: [] */}
          {/*    })); */}
          {/* }}>新增角色</Button> */}
          <div className='page-toolbar'>
            <FormCore formConfig={this.formConfig} />
          </div>
          <div className='page-panel'>
            <GridTable config={this.state.tableConfig} />
          </div>
        </div>
      </div>
    );
    return (
      <div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
        {Content}
      </div>
    );
  }
}

export default injectIntl(RoleList);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/role/roleList.js